import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Hint } from 'react-autocomplete-hint';
import { useState, useContext, useEffect } from 'react';
import { useQuery } from 'react-query';
import { FeedbackContext } from "../../../Components/Context/FeedbackContext";
import { Loading } from "../../../Components/Loading/Loading";
import { ErrorConnection } from "../../../Components/Error/Error";
import { Spinner } from 'react-bootstrap';
import * as Api from '../../../api/Api';
import { useGetToken } from '../../../Hooks/CustomHooks';
import { registerLocale } from 'react-datepicker';
import es from "date-fns/locale/es";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import $ from 'jquery';


export default function BitacoraEvento_Agregar({ setSmShow, unidadEconomica = null }) {

    const [guardar, setGuardar] = useState(false);
    const token = useGetToken();

    const [evento, setEvento] = useState('');

    const [dateDiaMes, setDateDiaMes] = useState(new Date());
    let dateFormatedDiaMes = ("0" + (dateDiaMes.getDate())).slice(-2) + "/" + ("0" + (dateDiaMes.getMonth() + 1)).slice(-2) + "/" + dateDiaMes.getFullYear();
    registerLocale('es', es);

    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);
    let { data, isLoading, isError, error, isFetching } = useQuery(
        ["BitacoraEvento_Agregar", {
            date: dateFormatedDiaMes, eventname: evento, token: token
        }],
        async () => await Api.BitacoraEvento_Agregar(
            { date: dateFormatedDiaMes, eventName: evento, token: token, unidadEconomicaId: unidadEconomica }
        ),
        {
            enabled: Boolean(guardar)
        }
    );

    useEffect(() => {
        if (data) {
            console.log(data);
            if (data.success == true) {
                setGuardar(false);
                setSmShow(true);
            } else {
                setFeedbackContext({ ...feedbackContext, showError: true, isError: data.errorId });
            }
        }
    }, [data]);

    if (isLoading) return (<Loading />)
    if (isError) return (<ErrorConnection error={error} />)
    return (
        <>
            <Modal

                show={true}
                aria-labelledby="contained-modal-title-vcenter"
                centered
                onHide={() => setSmShow(false)}
            >
                <Modal.Header className='header-personalizable' closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Agregar Evento
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group">
                        <div className='p-2'>
                            <div className="fw-bold fs-7 text-gray-600 mb-1">Fecha:</div>
                            <DatePicker
                                className="form-control form-control-transparent pe-5"
                                locale="es"
                                selected={dateDiaMes}
                                maxDate={new Date()}
                                dateFormat="dd/MM/yyyy"
                                onChange={(dateX) => setDateDiaMes(dateX)}
                            />
                        </div>

                        <br />
                        <div className="fw-bold fs-7 text-gray-600 mb-1">Evento:</div>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Nombre de evento"
                            value={evento}
                            onChange={(e) => setEvento(e.target.value)}
                        />
                        <label id='required_evento' style={{ display: 'none' }} className="text-danger">Ingrese Nombre de Evento</label>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => setSmShow(false)}>
                        Cerrar
                    </button>
                    <button type="submit" className="btn btn-primary" onClick={
                        () => {
                            if (evento != '') {
                                $('#required_evento').attr("style", "display='none'");
                                return setGuardar(true);
                            }
                            else {
                                if (evento == '') $('#required_evento').attr("style", "display='block'");
                                return null;
                            }
                        }
                    }>
                        Agregar
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
